import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store/store';
import { clearMethodStatus } from 'store/user-service/userSlice';

import { NamespacesList } from 'core/enums/common';

import { OperationResultModal } from 'components/Profile/Subscription/OperationResultModal';

export const MethodCancelModal = () => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const dispatch = useAppDispatch();

	return (
		<OperationResultModal
			title={modalTranslate('cancelMethodModal.title')}
			description={modalTranslate('cancelMethodModal.description')}
			confirm={modalTranslate('cancelMethodModal.confirm')}
			type={'cancel'}
			onClose={() => {
				dispatch(clearMethodStatus());
			}}
		/>
	);
};
